import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { storageUrl } from "@/services/config";
import api from "@/services/api";

interface Props {
  categoryName: string;
}

export default function CategoryBanner({ categoryName }: Props) {
  const [image, setImage] = useState("");
  const [mobileImage, setMobileImage] = useState("");
  const link = `/shop?category=${encodeURIComponent(categoryName)}`;

  useEffect(() => {
    api
      .get("/categories")
      .then((res) => {
        const cats = res.data || [];
        const found = cats.find((c: any) => c.name === categoryName);
        if (found?.image) setImage(storageUrl(found.image));
        if (found?.mobile_image) setMobileImage(storageUrl(found.mobile_image));
      })
      .catch(() => {});
  }, [categoryName]);

  return (
    <section className="bg-cream-50 pt-6 mb-0">
      <Link to={link} className="block w-full">
        {/* Desktop image */}
        <img
          src={
            image ||
            `https://placehold.co/1200x400/F5EDE7/999?text=${encodeURIComponent(categoryName)}`
          }
          alt={categoryName}
          className="hidden md:block w-full object-cover bg-cream-100"
        />
        {/* Mobile image */}
        <img
          src={
            mobileImage ||
            image ||
            `https://placehold.co/600x300/F5EDE7/999?text=${encodeURIComponent(categoryName)}`
          }
          alt={categoryName}
          className="md:hidden w-full object-cover bg-cream-100"
        />
      </Link>
    </section>
  );
}
